import { render } from "./GeoProvince.vue?vue&type=template&id=717971f4"
import script from "./GeoProvince.vue?vue&type=script&lang=js"
export * from "./GeoProvince.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__